import { useEffect } from 'react';
import { useStorage } from '../services/storageContext';
import { checkForAppUpdate, showUpdateNotification } from '../utils/cacheManager';

const VersionCheck = () => {
  const storage = useStorage();
  
  useEffect(() => {
    // Initialize app update checking
    checkForAppUpdate();
    
    // Also make storage service available globally for cache manager
    if (storage) {
      window.storageService = storage;
    }
    
    // Check version from server periodically
    const checkVersion = async () => {
      try {
        const response = await fetch('/version.json?t=' + Date.now());
        const newVersion = await response.json();
        
        const storedVersion = localStorage.getItem('app-version');
        
        if (storedVersion && storedVersion !== newVersion.commit) {
          console.log('New version detected:', newVersion.commit);
          
          // Check if we already showed notification for this version in this session
          const notificationShown = sessionStorage.getItem('version-notification-shown');
          if (notificationShown === newVersion.commit) {
            console.log('Notification already shown for version:', newVersion.commit);
            // Update stored version without showing notification again
            localStorage.setItem('app-version', newVersion.commit);
            return;
          }
          
          // Update the stored version immediately to prevent repeated notifications
          localStorage.setItem('app-version', newVersion.commit);
          sessionStorage.setItem('version-notification-shown', newVersion.commit);
          
          // Show the update notification
          showUpdateNotification();
        } else if (!storedVersion) {
          localStorage.setItem('app-version', newVersion.commit);
        }
      } catch (error) {
        console.error('Version check failed:', error);
      }
    };
    
    // Initial check after a short delay to ensure app is loaded
    setTimeout(checkVersion, 2000);
    
    // Check periodically but less frequently
    const interval = setInterval(checkVersion, 10 * 60 * 1000); // 10 minutes
    
    return () => {
      clearInterval(interval);
      if (window.storageService === storage) {
        delete window.storageService;
      }
    };
  }, [storage]);
  
  return null;
};

export default VersionCheck;